import React, { Fragment, useEffect, useState, useRef } from "react";
import Autocomplete from "react-google-autocomplete";
import Winery from "./winery/Winery";
import Comedy from "./comedy/Comedy";
import LocalMusic from "./localMusic/LocalMusic";
import TourTravel from "./tourTravel/TourTravel";
import EscapeRoom from "./escapeRoom/EscapeRoom";
import AdrenalineRush from "./adrenalineRush/AdrenalineRush";
import FamilyAttraction from "./familyAttraction/FamilyAttraction";
import PopularEntertainment from "./popularEntertainment/PopularEntertainment";
import { UsePlaceAuth } from "../../../AppContext/AppContext";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Rate } from "antd";
import { Things_to_do, setPlace } from "../../../Redux/Action/Action";
import { useDispatch, useSelector } from "react-redux";
import OwlCarousel from 'react-owl-carousel';
import SpcificPageModal from "../../Modals/SpcificPageModal";

function ThingsToDo() {
  const dispatch = useDispatch();
  const { setGameCatagory } = UsePlaceAuth() || {};
  const TopDealsRef = useRef(null);
  const [popularDeal, setPopularDeal] = useState([]);
  const [sportsFont, setSportsFont] = useState([]);
  const [sportsFontAll, setSportsFontAll] = useState();
  const [loader, setLoader] = useState(false);
  const place = useSelector(state => state.place);
  const [keyword, setKeyword] = useState("");
  let { SportsKeyword, setSportsKeyword } = UsePlaceAuth();
  const { BannerPic, setBannerPic } = UsePlaceAuth();
  let navigate = useNavigate();
  let location = useLocation();

  const options123 = {
    items: 4,
    loop: true,
    autoplay: true,
    autoplayTimeout: 2000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplayHoverPause: true,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      768: { items: 2 },
      991: { items: 4 }
    }
  };
  var settings = {
    slidesToShow: 4,
    loop: true,
    autoplay: true,
    autoplayTimeout: 3000,
    autoplayHoverPause: true,
    smartSpeed: 500,
    slidesToScroll: 1,
    nav: true,
    dots: false,
    responsive: {
      0: { items: 1 },
      600: { items: 2 },
      991: { items: 4 }
    }
  };

  const BannerImage = async () => {
    setLoader(true);
    let payload = { city: place };
    let apiRes = await apiData.Ban_Image(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setBannerPic(apiRes?.data?.hits[0]?.largeImageURL);
      setLoader(false);
    }
  };

  const handlePopularDealClick = async (e) => {
    if (e && typeof e.preventDefault === 'function') {
      e.preventDefault();
    }
    handleScroll();
    setLoader(true);
    let keyword = e && e.target && e.target.alt ? e.target.alt : (typeof e === 'string' ? e : '');
    let payload = {
      city: place,
      keyword,
      limit: 12
    };
    let apiRes = await apiData.getYelpDeals(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399) {
      setPopularDeal(apiRes?.data?.data?.businesses);
      setLoader(false);
    }
  };

  const handleScroll = () => {
    TopDealsRef.current.scrollIntoView({ behavior: "smooth" });
  };

  const GetTickets = async () => {
    let payload = { city: place };
    let apiRes = await apiData.Sports_Tickets_Things_To_Do(payload);
    if (apiRes?.status >= 200 && apiRes?.status <= 399 && apiRes?.data?.data?.length > 0) {
      setLoader(true);
      setSportsFont(Object.keys(apiRes?.data?.data[0]));
      setSportsFontAll(apiRes?.data?.data[0]);
      setLoader(false);
    }
    if (apiRes?.statu0s >= 400 && apiRes?.status <= 500) {
      console.log("error");
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const [visibleItems, setVisibleItems] = useState(4);
  const lastItemRef = useRef(null);

  const loadMore = () => {
    setIsLoading(true);
    setTimeout(() => {
      setVisibleItems(prev => prev + 4);
      setIsLoading(false);
    }, 1000);
  };

  useEffect(() => {
    if (lastItemRef.current) {
      lastItemRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [visibleItems]);

  const handleSearch = (e) => {
    if (e.key.toLowerCase() === "enter") {
      e.preventDefault();
      const newPlace = e.target.value.toLowerCase();
      const currentPath = location.pathname;
      const match = currentPath.match(/^\/things-to-do\/?([^/]*)/);
      const currentPlace = match && match[1] ? match[1].toLowerCase() : "";
      if (currentPlace !== newPlace) {
        navigate(`/things-to-do/${newPlace}`);
      }
      dispatch(setPlace(newPlace));
    }
  };

  useEffect(() => {
    dispatch(Things_to_do());
    if (place) {
      GetTickets();
    }
    BannerImage();
  }, [place]);

  const [specificModal, setSpecificModal] = useState(false);
  useEffect(() => {
    const hasSeenPopup = localStorage.getItem("hasSeenSpecficPopup");
    if (!hasSeenPopup) {
      setSpecificModal(true);
      localStorage.setItem("hasSeenSpecficPopup", "true");
    }
    if (place && !hasSeenPopup) {
      setSpecificModal(true);
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        localStorage.setItem("lastSeen", Date.now());
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [place]);

  // Data for popular things to do
  const popularThings = [
    { label: "Museum", img: "things1.png", alt: "Museum" },
    { label: "Sightseeing/tours", img: "seeingtours.png", alt: "Sightseeing" },
    { label: "Day Trip", img: "ttd_img3.png", alt: "Day trip" },
    { label: "Top Attractions", img: "ttd_img4.png", alt: "Top attractions" },
    { label: "Night Life", img: "Nightlife.png", alt: "NightLife" },
    { label: "Shopping", img: "Shopping.png", alt: "Shopping" },
    { label: "Fine Dining", img: "fine-dining.png", alt: "Fine dinning" },
  ];

  // Handler for popular deal click
  const handlePopularDealItemClick = (alt) => (e) => {
    setKeyword(alt);
    handlePopularDealClick(alt); // Pass alt directly, not a fake event
    handleScroll();
  };

      const localSelectedCity = localStorage.getItem('selectedCity');

  return (
    <Fragment>
      <div className="banner-section rest-sec things" style={{ backgroundImage: BannerPic ? `url(${BannerPic})` : "" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
              <div className="tab-content" id="myTabContent">
                <div className="tab-pane fade show active" id="hotel-tab-pane" role="tabpanel" tabIndex="0">
                  <div className="select-form restaurent-sec">
                    <form>
                      <div className="choose-sec">
                        <Autocomplete
                          className="form-control"
                          apiKey="AIzaSyDrSVPFOzjxmlv2WLSnfJ0ARrmYP9QDajs"
                          placeholder={
                            localSelectedCity && localSelectedCity !== "undefined" && place
                              ? place.replace(/\b\w/g, (x) => x.toUpperCase())
                              : "Search for a city or place"
                          }
                          onPlaceSelected={async (city) => {
                            if (city && city.formatted_address) {
                              const cityName = city.formatted_address.split(',')[0].toLowerCase();
                              await dispatch(setPlace(cityName));
                              navigate(`/things-to-do/${cityName}`);
                              localStorage.setItem('selectedCity', city.formatted_address.split(',')[0]);
                            }
                          }}
                          onKeyPress={handleSearch}
                        />
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="adver-sec">
        <div className="container">
          <div className="row">
            <div className="">
              <a href="https://www.anrdoezrs.net/click-8265264-13820699" target="_top">
                <img loading="lazy" src="https://www.lduhtrp.net/image-8265264-13820699" width="728" height="90" alt="Vrbo" border="0" /></a>
            </div>
          </div>
        </div>
      </div>
      <div className="itemBox" style={{ marginTop: "10px", marginBottom: "10px" }}>
        <div className="rind-the-right-section comedy-sec">
          <div className="container">
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div className="white-box-area inner rest-deals">
                  <div className="row">
                    <div className="col-lg-12 col-12">
                      <section className="client-sec comedy">
                        <Fragment>
                          <TourTravel />
                          <AdrenalineRush />
                        </Fragment>
                        <div className="flight-sec exitment-sec">
                          <div className="container">
                            <div className="slider-sec">
                              <h2>Sports Tickets</h2>
                              <p>Enjoy the local pass time</p>
                              {sportsFontAll && (
                                <div className="slider-main">
                                  <OwlCarousel {...options123}>
                                    {Object.keys(sportsFontAll)?.map((ele, index) => (
                                      <div key={index} className="slide-things2">
                                        <Link to={place ? `/sports/${place}` : `/sports`}>
                                          <div className="slider-block" onClick={() => {
                                            setSportsKeyword(sportsFontAll[ele]);
                                            if (typeof setGameCatagory === 'function') {
                                              setGameCatagory(sportsFontAll[ele]);
                                            }
                                          }}>
                                            {ele === "MLB" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/mlb.png`} alt="MLB" />}
                                            {ele === "NBA" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/nba.png`} alt="NBA" />}
                                            {ele === "NFL" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/nfl.png`} alt="NFL" />}
                                            {ele === "NHL" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/nhl.png`} alt="NHL" />}
                                            {ele === "MLS" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/mls.png`} alt="MLS" />}
                                            {ele === "CFL" && <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/cfl.png`} alt="CFL" />}
                                            <div className="slider-content local">
                                              <h3>{ele}</h3>
                                            </div>
                                          </div>
                                        </Link>
                                      </div>
                                    ))}
                                  </OwlCarousel>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="flight-sec exitment-sec">
                          <div className="slider-sec">
                            <h3>Popular things to do</h3>
                            <div>
                              Find fun places to see and things to do experience the art, museums,
                              music, zoo
                            </div>
                            <div className="col-12 col-md-12 col-lg-12">
                              <OwlCarousel {...settings}>
                                {popularThings.map((item, idx) => (
                                  <div data-aos="zoom-in-right" className="slider-main" key={item.alt}>
                                    <div className="slider-block clickable" onClick={handlePopularDealItemClick(item.alt)}>
                                      <img loading="lazy" className="ResoImage" src={`${process.env.REACT_APP_IMAGE_URL}backend/assets/images/city_images/${item.img}`} alt={item.alt} />
                                      <div className="slider-content">
                                        <h3>{item.label}</h3>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </OwlCarousel>
                            </div>
                          </div>
                        </div>
                        <PopularEntertainment />
                        <LocalMusic />
                        <div className="adver-sec">
                          <div className="container">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <a href="https://www.kqzyfj.com/click-8265264-15098222" target="_top">
                                  <img loading="lazy" src="https://www.tqlkg.com/image-8265264-15098222" width="728" height="90" alt="" border="0" /></a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <EscapeRoom />
                        <FamilyAttraction />
                        <Winery />
                        <Comedy />
                        <div className="adver-sec">
                          <div className="container">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <a href="https://www.tkqlhce.com/click-8265264-13167950" target="_top">
                                  <img loading="lazy" src="https://www.lduhtrp.net/image-8265264-13167950" width="728" height="90" alt="" border="0" /></a>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="slider-main">
                          <div className="slider-heading" ref={TopDealsRef}>
                            {keyword && place ? <h3>{`${keyword} in ${place.replace(/\b\w/g, x => x.toUpperCase())}`}</h3> : ""}
                          </div>
                          {!loader ? (
                            <div className="row">
                              {popularDeal &&
                                popularDeal.slice(0, visibleItems).map((ele, index) => (
                                  <div
                                    key={index}
                                    className="col-12 col-sm-6 col-md-4 col-lg-3"
                                    ref={index === visibleItems - 1 ? lastItemRef : null}
                                  >
                                    <a href={ele?.url} target="_blank" rel="noreferrer">
                                      <div className="slider-block">
                                        <img loading="lazy" src={ele?.image_url} alt="" />
                                        <div className="slider-content">
                                          <h3>{ele?.name}</h3>
                                        </div>
                                        <div className="stars">
                                          <ul>
                                            <li>
                                              <Rate allowHalf defaultValue={ele?.rating} disabled />
                                            </li>
                                          </ul>
                                          <p>{ele?.review_count} Reviews</p>
                                        </div>
                                      </div>
                                    </a>
                                  </div>
                                ))}
                            </div>
                          ) : (
                            <DataLoader />
                          )} <br />
                          {visibleItems < popularDeal.length && (
                            <div className="view-tag clickable">
                              <a onClick={loadMore} className="">
                                {isLoading ? 'Loading...' : 'Load More'}
                              </a>
                            </div>
                          )}
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <>
        {specificModal && (
          <SpcificPageModal
            specificModal={specificModal}
            setSpecificModal={setSpecificModal}
          />
        )}
      </>
    </Fragment>
  );
}

export default ThingsToDo;
